/**
 * @generated SignedSource<<cf111b20b1987496615a83830e26668e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issueCreateFooter_nativeIssueTable_rankField$data = {
  readonly fieldId: string | null | undefined;
  readonly " $fragmentType": "issueCreateFooter_nativeIssueTable_rankField";
};
export type issueCreateFooter_nativeIssueTable_rankField$key = {
  readonly " $data"?: issueCreateFooter_nativeIssueTable_rankField$data;
  readonly " $fragmentSpreads": FragmentRefs<"issueCreateFooter_nativeIssueTable_rankField">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "issueCreateFooter_nativeIssueTable_rankField",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    }
  ],
  "type": "JiraJqlFieldWithAliases"
};

(node as any).hash = "d0a12b45f009f78d0bf2fc160795df5d";

export default node;
